import { toast } from "sonner";
import { DevSignInButton, type ShowArgs } from "@/components/DevSignInButton";

const TITLE = "Code sent (dev mode)";

/**
 * Shows the dev "Sign me in" shortcut toast. Returns the toast id so the
 * caller can `toast.dismiss(id)` once the user signs in by other means.
 */
export function showDevSignInToast({
  email,
  name,
  onSignedIn,
}: ShowArgs): string | undefined {
  if (!import.meta.env.DEV) return undefined;

  const id = `dev-sign-in-${Date.now()}`;
  toast.message(TITLE, {
    id,
    description: "Click to auto-verify with the captured email.",
    duration: 30000,
    action: (
      <DevSignInButton toastId={id} email={email} name={name} onSignedIn={onSignedIn} />
    ),
  });
  return id;
}
